import React from 'react'
import { Button as UiKitBtn, ConnectorNames, InjectedModalProps, Modal, Text, ButtonProps } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { getActivateErrorHandler, isChainCorrect, setupNetwork } from 'utils/wallet'
import { useWeb3React } from '@web3-react/core'
import useToast from 'hooks/useToast'
import { useConnectionError } from 'state/user/hooks'
import { connectorsByName } from 'utils/web3React'

const SwitchNetworkModal: React.FC<InjectedModalProps & { ActionButton?: React.FC<ButtonProps> }> = ({
  onDismiss,
  ActionButton = DefaultActionBtn,
}) => {
  const { t } = useTranslation()
  const { theme } = useTheme()
  const { activate } = useWeb3React()
  const { toastError } = useToast()
  const [connectionError, setConnectionError] = useConnectionError()

  const handleClick = async () => {
    if (
      connectionError?.connectorID === ConnectorNames.Metamask ||
      connectionError?.connectorID === ConnectorNames.BraveWallet ||
      connectionError?.connectorID === ConnectorNames.Injected
    ) {
      const connector = connectorsByName[connectionError.connectorID]
      const errorHandler = getActivateErrorHandler(connectionError.connectorID, t, toastError, setConnectionError)
      await setupNetwork()
      const hasSwitchedChain = await isChainCorrect()
      if (hasSwitchedChain) {
        setConnectionError(null)
        activate(connector, errorHandler)
        onDismiss()
      }
    }
  }

  return (
    <Modal title="" onDismiss={onDismiss} style={{ maxWidth: '420px' }} bodyPadding="0 24px 24px 24px">
      <Text textAlign="center">
        <img
          src={theme.isDark ? '/images/wrong-network-dark.png' : '/images/wrong-network-light.png'}
          alt={t('Wrong Network')}
          width={110}
        />
      </Text>
      <Text fontSize="28px" textAlign="center">
        {t('Wrong Network')}
      </Text>
      <Text textAlign="center" color={theme.isDark ? theme.colors.grey : theme.colors.darkGrey}>
        {t('Please connect to the appropriate network.')}
      </Text>
      <ActionButton onClick={handleClick}>{t('Switch to Cronos Chain')}</ActionButton>
    </Modal>
  )
}

export default SwitchNetworkModal

const DefaultActionBtn: React.FC<ButtonProps> = (props) => <UiKitBtn mt="24px" {...props} />
